import {Component, Input, OnInit} from '@angular/core';
import {
    DownloadState, UploadAssetsService, UploadState, UploadStatus,
    UploadStatusLabels
} from "../../services/upload-assets.service";

import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";


@Component({
  selector: 'app-upload-assets-widget',
  templateUrl: './upload-assets-widget.component.html',
  styleUrls: ['./upload-assets-widget.component.scss']
})
export class UploadAssetsWidgetComponent implements OnInit {

    isShown = false;
    type = 'upload';
    progress: {
        progress: number,
        info: string,
        status: string
    };

    isPackageUploading: boolean;

    constructor(private uploadAssetsService: UploadAssetsService, private router: Router) {
    }

    ngOnInit() {
        this.progress = {
            progress: 0,
            status: '',
            info: ''
        };
        this.uploadAssetsService.uploadingProgress.subscribe(this.progressHandler.bind(this));
        this.uploadAssetsService.progressStatus.subscribe((status) => {
            this.isPackageUploading = status;
        });

        this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            let route = event.url;
            if(route === '/' || route === '/settings'){
                this.isShown = false;
            }else{
                this.isShown = true;
            }
        });

    }

    progressHandler(state: UploadState|DownloadState) {
        this.type = state.type;
        if (state.status === UploadStatus.Finished) {
            this.progress = {
                progress: 0,
                status: '',
                info: ''
            };
        } else {
            this.progress = {
                progress: state.progress,
                status: UploadStatusLabels[state.status],
                info: state.info
            };
        }
    }

    cancel() {
        this.uploadAssetsService.cancel();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/upload-assets-widget/upload-assets-widget.component.ts